import { duration } from '../utils/duration';

/**
 * Max energy that can be claimed from in-game rewards (e.g. friend invites)
 */
export const maxRewardedEnergy = 99;

export const maxEventEnergy = 5;

export const maxMinigameEnergy = {
  default: 5,
};

export const energyRegenerationConfig = {
  slotMachine: {
    amount: 1,
    time: duration({ minutes: 4, seconds: 30 }),
  },
  match2: {
    amount: 1,
    time: duration({ minutes: 30 }),
  },
  default: {
    amount: 1,
    time: duration({ minutes: 45 }),
  },
};
